function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "A",
  width: 107.028,
  height: 65.227,
  rx: 2.545
}), /*#__PURE__*/React.createElement("mask", {
  id: "B",
  x: 0,
  y: 0,
  width: 107.028,
  height: 65.227,
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#A"
})), /*#__PURE__*/React.createElement("rect", {
  id: "C",
  width: 73.182,
  height: 65.227,
  rx: 2.545
}), /*#__PURE__*/React.createElement("mask", {
  id: "D",
  x: 0,
  y: 0,
  width: 73.182,
  height: 65.227,
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "0%",
  y1: "0%",
  x2: "100%",
  y2: "100%",
  id: "E"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00baff",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#007cff",
  offset: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#e3e9f0",
  opacity: 0.6,
  x: 12.727,
  y: 74.773,
  width: 127.273,
  height: 4.773,
  rx: 2.386
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(23.66 14.318)",
  stroke: "#b3becd"
}, /*#__PURE__*/React.createElement("g", {
  strokeWidth: 3.182,
  strokeDasharray: "3.181818181818182,1.590909090909091"
}, /*#__PURE__*/React.createElement("use", {
  mask: "url(#B)",
  fill: "#f5f8fa",
  xlinkHref: "#A"
}), /*#__PURE__*/React.createElement("use", {
  mask: "url(#D)",
  fill: "#fff",
  xlinkHref: "#C"
})), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeWidth: 1.591
}, /*#__PURE__*/React.createElement("path", {
  d: "M31.86 36.607l9-9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.86 36.607l-9-9"
}))), /*#__PURE__*/React.createElement("circle", {
  fill: "#fff",
  opacity: 0.6,
  cx: 25.632,
  cy: 16.431,
  r: 13.802
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.36 0c9.035 0 16.36 7.324 16.36 16.36 0 3.674-1.21 7.066-3.257 9.797l11.917 11.918a2.34 2.34 0 0 1 0 3.305 2.34 2.34 0 0 1-3.305 0h0L26.156 29.46c-2.73 2.045-6.122 3.257-9.797 3.257C7.324 32.718 0 25.393 0 16.36S7.324 0 16.36 0zm0 4.674c-6.453 0-11.685 5.23-11.685 11.685s5.23 11.685 11.685 11.685 11.685-5.23 11.685-11.685S22.812 4.674 16.36 4.674z",
  fill: "url(#E)",
  transform: "matrix(-1 0 0 1 42.062594 0)"
}));

function SvgErrorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 140,
    height: 81,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.b9557408.svg";
export { ForwardRef as ReactComponent };